import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transportcompanyemployees',
  templateUrl: './transportcompanyemployees.component.html',
  styleUrls: ['./transportcompanyemployees.component.css']
})
export class TransportcompanyemployeesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
